import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getDoneWorksDocuments(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENTS,
		options
	)
}
function _getDoneWorksDocumentPreview(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENT_PREVIEW,
		options
	)
}
function _getDoneWorksDocumentPopup(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENT_POPUP,
		options
	)
}

function _createDoneWorksDocument(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].CREATE_DONE_WORKS_DOCUMENT,
		options
	)
}

function _getDoneWorksDocument(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENT,
		options
	)
}

function _patchDoneWorksDocument(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].PATCH_DONE_WORKS_DOCUMENT,
		options
	)
}

function _putDoneWorksDocument(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].PUT_DONE_WORKS_DOCUMENT,
		options
	)
}

function _deleteDoneWorksDocument(options = {}) {
	return _apiRequestWrap(
		ModulesMap.DONE_WORKS_DOCUMENTS,
		ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].DELETE_DONE_WORKS_DOCUMENT,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENTS]: _getDoneWorksDocuments,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENT_PREVIEW]: _getDoneWorksDocumentPreview,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENT_POPUP]: _getDoneWorksDocumentPopup,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].CREATE_DONE_WORKS_DOCUMENT]: _createDoneWorksDocument,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].GET_DONE_WORKS_DOCUMENT]: _getDoneWorksDocument,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].PATCH_DONE_WORKS_DOCUMENT]: _patchDoneWorksDocument,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].PUT_DONE_WORKS_DOCUMENT]: _putDoneWorksDocument,
	[ModulesConfigMap[ModulesMap.DONE_WORKS_DOCUMENTS].DELETE_DONE_WORKS_DOCUMENT]: _deleteDoneWorksDocument,
}